import { Outlet } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import { NotFoundPage } from '../../pages/NotFoundPage'

type PermissionRouteProps = {
  permission: string
}

/** Route guard: authenticated users without access see 404 (not login). */
export function PermissionRoute({ permission }: PermissionRouteProps) {
  const { can } = useAuth()

  if (!can(permission)) {
    return <NotFoundPage />
  }

  return <Outlet />
}
